import React, { useMemo, useState } from 'react';
import { AlertTriangle, CheckCircle2, Trash2 } from 'lucide-react';
import { useAppStore } from '../../../../app/hooks/useAppStore';
import { detectOrphanedClassrooms, cleanupOrphans } from '../../../../accounts';
import { Button } from '../../../../components/ui/Button';
import { Card } from '../../../../components/ui/Card';
import { ConfirmDialog } from '../../../../components/shared/ConfirmDialog';
export function OrphanStatus() {
  const {
    accounts,
    setAccountsState
  } = useAppStore();
  const [isCleaning, setIsCleaning] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const report = useMemo(() => detectOrphanedClassrooms(accounts), [accounts]);
  const handleCleanup = () => {
    setIsCleaning(true);
    setTimeout(() => {
      const nextState = cleanupOrphans(accounts, report);
      setAccountsState(nextState);
      setIsCleaning(false);
      setShowConfirm(false);
    }, 500);
  };
  if (report.totalIssues === 0) {
    return <Card className="p-8 text-center border-emerald-200 bg-emerald-50/50" data-id="element-7847" data-mp="2d8usiel4srx">
        <div className="flex justify-center mb-4" data-id="element-7848" data-mp="2fbobcey541e">
          <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600" data-id="element-7849" data-mp="3uimens68ik9m">
            <CheckCircle2 className="w-6 h-6" data-id="element-7850" data-mp="cd9azvh5qsrw" />
          </div>
        </div>
        <h3 className="text-lg font-bold text-emerald-900 mb-2" data-id="element-7851" data-mp="7bjysci78928">
          Geen wees-records gevonden
        </h3>
        <p className="text-emerald-700 text-sm" data-id="element-7852" data-mp="latgjgm1zb8b">
          De database is gezond. Alle klassen hebben een eigenaar en alle
          gekoppelde co-docenten en leerlingen bestaan.
        </p>
      </Card>;
  }
  return <div className="space-y-6" data-id="element-7853" data-mp="v4a96hagekae">
      <Card className="p-6 border-amber-200 bg-amber-50/50" data-id="element-7854" data-mp="q3cr04pg1q8w">
        <div className="flex items-start justify-between" data-id="element-7855" data-mp="q562bxb04yn8">
          <div className="flex items-start gap-4" data-id="element-7856" data-mp="151f0evj5p5y2">
            <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center text-amber-600 flex-shrink-0 mt-1" data-id="element-7857" data-mp="14xzg9eaml6ps">
              <AlertTriangle className="w-5 h-5" data-id="element-7858" data-mp="1758ka2a30qo0" />
            </div>
            <div data-id="element-7859" data-mp="1c3juie4ah36r">
              <h3 className="text-lg font-bold text-amber-900 mb-1" data-id="element-7860" data-mp="1c30nvtk3a181">
                {report.totalIssues} wees-records gevonden
              </h3>
              <p className="text-amber-700 text-sm mb-4" data-id="element-7861" data-mp="1h12323ee9ge8">
                Er zijn klassen of koppelingen gevonden waarvan het bijbehorende
                account niet meer bestaat. Dit kan gebeuren bij hard-deletes of
                inconsistente migraties.
              </p>
              <ul className="space-y-2 text-sm text-amber-800" data-id="element-7862" data-mp="1ut0am9sgj48a">
                {report.orphanedClassrooms.length > 0 && <li data-id="element-7863" data-mp="1ztxnq7ym182x">
                    <span className="font-bold" data-id="element-7864" data-mp="1zrbf04zzgmj4">
                      {report.orphanedClassrooms.length}
                    </span>{' '}
                    klassen zonder eigenaar
                  </li>}
                {report.orphanedCoTeachers.length > 0 && <li data-id="element-7865" data-mp="agapwl68uurd">
                    <span className="font-bold" data-id="element-7866" data-mp="2up0ikbjivrw">
                      {report.orphanedCoTeachers.length}
                    </span>{' '}
                    ontbrekende co-docenten
                  </li>}
                {report.orphanedLearners.length > 0 && <li data-id="element-7867" data-mp="3p85la1bt5uer">
                    <span className="font-bold" data-id="element-7868" data-mp="3kbf8bmvavexk">
                      {report.orphanedLearners.length}
                    </span>{' '}
                    ontbrekende leerlingen in klassen
                  </li>}
              </ul>
            </div>
          </div>
          <Button onClick={() => setShowConfirm(true)} className="bg-amber-600 hover:bg-amber-700 text-white" data-id="element-7869" data-mp="gslzfndgve9q">
            <Trash2 className="w-4 h-4 mr-2" data-id="element-7870" data-mp="6v8wvloahvcz" />
            Opschonen
          </Button>
        </div>
      </Card>

      <ConfirmDialog open={showConfirm} title="Wees-records opschonen" message={`Weet je zeker dat je ${report.totalIssues} wees-records wilt verwijderen? Klassen zonder eigenaar worden volledig verwijderd. Ontbrekende co-docenten en leerlingen worden uit hun klassen gehaald.`} confirmLabel={isCleaning ? 'Bezig...' : 'Ja, schoon op'} cancelLabel="Annuleren" variant="danger" onConfirm={handleCleanup} onCancel={() => setShowConfirm(false)} data-id="element-7871" data-mp="2wmdutl7m1dlf" />
    </div>;
}